/**
 * Sentinel a validator can emit as an issue message to signal that the issue
 * should be dropped rather than surfaced to the user.
 */
export const OMIT_ERROR = '__omit__';
const getMessageByCode = (code, catalog) => {
    const [topLevelKey, ...nestedKeys] = code.split('.');
    const value = topLevelKey ? catalog[topLevelKey] : undefined;
    if (typeof value === 'string') {
        return nestedKeys.length ? '' : value;
    }
    return value && nestedKeys.length
        ? getMessageByCode(nestedKeys.join('.'), value)
        : '';
};
/**
 * Maps Zod issues to {@link ValidationError}s. Generic and free of any business
 * domain logic — the caller owns the catalog.
 *
 * - Issues whose message equals {@link OMIT_ERROR} are always skipped.
 * - With a `catalog`, each issue's code is resolved to a message; codes with no
 *   catalog entry are dropped (there is nothing to show).
 * - Without a `catalog`, every issue is kept with an empty `message`, leaving the
 *   caller (e.g. a validation checklist) to translate the `code` itself.
 */
export const remapZodErrors = (issues, catalog) => {
    const errors = [];
    for (const issue of issues) {
        if (issue.message === OMIT_ERROR) {
            continue;
        }
        const message = catalog ? getMessageByCode(issue.message, catalog) : '';
        if (catalog && !message) {
            continue;
        }
        errors.push({
            code: issue.message,
            message,
            path: [...issue.path],
        });
    }
    return errors;
};
